module.exports = __webpack_public_path__ + "static/media/completed.2bee0132.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/completed.svg
// module id = 869
// module chunks = 21